import {
  DeleteMetafieldRequestBodyType,
  ReadmeLoginResponseBodyType,
} from "@intelligems/ig-types";
import { ApiRequest } from "@src/api/types/api";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const deleteMetafield = async (
  data: ApiRequest<DeleteMetafieldRequestBodyType>
) => {
  const resp = await api.delete<ReadmeLoginResponseBodyType>("/v2/metafields", {
    data: data.body,
  });
  return resp.data;
};

export const useDeleteMetafield = () => {
  return useMutation<ReadmeLoginResponseBodyType, Error, any, any>({
    mutationFn: async (data: ApiRequest<DeleteMetafieldRequestBodyType>) =>
      deleteMetafield(data),
  });
};
